// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2Ju1A","left":"StickyBox_left__1Je31","right":"StickyBox_right__3WkwI"};